@if (isVisible()) {
    <div
        class="dc-event-overlay"
        [class.active]="!isHiding()"
        [style.--event-overlay-hide-duration]="hideDuration() + 'ms'">
        <div class="overlay-content">
            @for (text of texts(); track $index) {
                <div class="message">
                    @if (text.message) {
                        <div
                            [dcTypography]="text.typography ?? 'bulevar-32'"
                            dcColor="wire-white-fixed"
                            [class]="isHiding() ? text.hideAnimation : text.showAnimation">
                            {{ text.message }}
                        </div>
                    }

                    @if (text.imagePath) {
                        <img
                            [src]="text.imagePath"
                            [class]="isHiding() ? text.hideAnimation : text.showAnimation"
                            alt="Event Image" />
                    }
                </div>
            }
        </div>
    </div>
}
